import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { initializeSentry } from "./config/sentry";
import { USE_SENTRY } from "./config/constants";
import { ErrorView } from "@data-root/error-boundary";
import { App } from ".";

// Initialize Sentry with environment-based configuration
initializeSentry({
  enabled: process.env.NODE_ENV !== "development" && USE_SENTRY,
});

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <Sentry.ErrorBoundary fallback={ErrorView as any}>
    <App />
  </Sentry.ErrorBoundary>
);
